module.exports = __webpack_public_path__ + "static/introdashboard-fc08c193c3b9f005db3e9b1727739dce.svg";